import "angular";
import Base64EncoderService from "./Base64EncoderService";
import SamlSsoService from "./SamlSsoService";

const SamlSsoModule = angular
    .module("SamlSsoModule", [])
    .service("SamlSsoService", SamlSsoService)
    .service("base64EncoderService", Base64EncoderService);

export default SamlSsoModule;
